"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _aemReactEditableComponents = require("@adobe/aem-react-editable-components");
var _styles = require("@material-ui/core/styles");
var __jsx = _react.default.createElement;
var TopNavigationEditConfig = {
  emptyLabel: 'Top Navigation',
  isEmpty: function isEmpty(props) {
    if (props.items && props.items.length > 0) {
      return false;
    } else {
      return true;
    }
  }
};
function ChildPage(_ref) {
  var childrenpage = _ref.childrenpage;
  var nestedChildren = (childrenpage.childrens || []).map(function (childrenpage) {
    return __jsx(ChildPage, {
      childrenpage: childrenpage
    });
  });
  return __jsx("div", null, __jsx("ul", {
    style: {
      listStyleType: 'disc'
    }
  }, __jsx("li", null, __jsx("a", {
    href: childrenpage.url,
    target: childrenpage.openNewTab ? '_blank' : '',
    rel: childrenpage.openNewTab ? 'noopener noreferrer' : undefined,
    dangerouslySetInnerHTML: {
      __html: childrenpage.title
    }
  }), nestedChildren)));
}
function AdditionalColumnsLinks(_ref2) {
  var additionalLinks = _ref2.additionalLinks;
  return __jsx("ul", null, (additionalLinks || []).map(function (additionalLink) {
    return __jsx("div", null, additionalLink.image && null !== additionalLink.image ? __jsx("div", null, __jsx("img", {
      src: additionalLink.image,
      title: additionalLink.title,
      alt: additionalLink.altText,
      height: "200px",
      width: "250px"
    })) : null, __jsx("li", null, __jsx("a", {
      href: additionalLink.url,
      dangerouslySetInnerHTML: {
        __html: additionalLink.title
      },
      target: additionalLink.openNewTab ? '_blank' : '',
      rel: additionalLink.openNewTab ? 'noopener noreferrer' : undefined
    })));
  }));
}
var TopNavigation = function TopNavigation(props) {
  var theme = (0, _styles.useTheme)();
  var title = props.title,
    items = props.items,
    additionalColumnHeading = props.additionalColumnHeading,
    additionalLinks = props.additionalLinks;
  return __jsx("div", null, __jsx("span", {
    style: {
      color: theme.palette.vibrant.green,
      fontWeight: 900
    },
    dangerouslySetInnerHTML: {
      __html: "".concat(title ? title : '')
    }
  }), (items || []).map(function (childrenpage) {
    return __jsx(ChildPage, {
      childrenpage: childrenpage
    });
  }), additionalLinks ? __jsx("span", {
    style: {
      color: theme.palette.vibrant.green,
      fontWeight: 900,
      textDecoration: 'underline'
    }
  }, "Additional Column:", ' ', __jsx("span", {
    dangerouslySetInnerHTML: {
      __html: "".concat(additionalColumnHeading ? additionalColumnHeading : '')
    }
  })) : '', __jsx(AdditionalColumnsLinks, {
    additionalLinks: additionalLinks
  }));
};
var _default = (0, _aemReactEditableComponents.MapTo)('cms-commons/components/content/topnavigation')(TopNavigation, TopNavigationEditConfig);
exports.default = _default;